import {
  ButtonGroup as MantineButtonGroup,
  ButtonGroupProps,
} from '@mantine/core';

export type IButtonGroupProps = ButtonGroupProps;

/** @registry Design-layer pass-through over Mantine Button.Group for segmented button rows; compose with BasicButton children instead of importing @mantine/core Button for its .Group static. */
export const ButtonGroup = MantineButtonGroup;
